export interface WalletLike {
    currency: string;
    balance?: number | string;
    tot_in?: number | string;
    tot_out?: number | string;
    fido?: number | string;
    wallet_type?: string;
}

export function getWalletsBalance(wallets: WalletLike[], currency: string): number {
    return (wallets || [])
        .filter(w => w.currency === currency)
        .reduce((carry, wallet) => carry + (parseFloat(String(wallet.balance)) || 0), 0);
}

export function getWalletsTotIn(wallets: WalletLike[], currency: string): number {
    return (wallets || [])
        .filter(w => w.currency === currency)
        .reduce((carry, wallet) => carry + (parseFloat(String(wallet.tot_in)) || 0), 0);
}

export function getWalletsTotOut(wallets: WalletLike[], currency: string): number {
    return (wallets || [])
        .filter(w => w.currency === currency)
        .reduce((carry, wallet) => carry + (parseFloat(String(wallet.tot_out)) || 0), 0);
}

export function getWalletsFido(wallets: WalletLike[], currency: string): number {
    return (wallets || [])
        .filter(w => w.currency === currency)
        .reduce((carry, wallet) => carry + (parseFloat(String(wallet.fido)) || 0), 0);
}

/**
 * Nota: Mantiene la logica originale che somma il 'fido' 
 * per i wallet di tipo 'bonus'
 */
export function getWalletsBonus(wallets: WalletLike[], currency: string): number {
    return (wallets || [])
        .filter(w => w.currency === currency && w.wallet_type === 'bonus')
        .reduce((carry, wallet) => carry + (parseFloat(String(wallet.fido)) || 0), 0);
}